import type { Middleware } from "@reduxjs/toolkit";
import {
  configureStore,
  isRejected,
  isRejectedWithValue,
} from "@reduxjs/toolkit";

import listenerMiddleware from "./listenerMiddleware";
import { rootReducer } from "./slices";

const abortMiddleware: Middleware =
  // eslint-disable-next-line unicorn/consistent-function-scoping
  () => (next) => (action) => {
    if (isRejected(action) && action.meta.aborted) {
      return;
    }
    return next(action);
  };

export const rtkMiddlewareErrorLogger: Middleware =
  // eslint-disable-next-line unicorn/consistent-function-scoping
  () => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      console.warn(
        `We got a rejected action: ${action.type}`,
        action.payload,
        action.error,
      );
    }
    return next(action);
  };

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    // eslint-disable-next-line unicorn/prefer-spread
    getDefaultMiddleware().concat(
      abortMiddleware,
      rtkMiddlewareErrorLogger,
      listenerMiddleware,
    ),
});

export type AppDispatch = typeof store.dispatch;
